/* Format state language "es" */
export default value => {
  return value ? "Pagado" : "Pendiente";
};



// WEBPACK FOOTER //
// ./src/filters/formatPaid.js